import { useParams } from "react-router-dom";
import PostRenderer from "../components/PostRenderer";

const NewsPostPage = () => {
  const { slug } = useParams();
  return <PostRenderer slug={slug} folderName="news" />;
};

export default NewsPostPage;
